/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Skip_LabelInputs */

const en_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip current correction`)
};

const fr_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer la correction actuelle`)
};

const de_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Korrektur überspringen`)
};

const it_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta la correzione corrente`)
};

const ru_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропустить текущую коррекцию`)
};

const es_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir la corrección actual`)
};

const zh_cn2_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳过当前校正`)
};

const ja_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の修正をスキップ`)
};

const hi_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान सुधार को छोड़ें`)
};

const pt_pt2_spellcheck_skip_label = /** @type {(inputs: Spellcheck_Skip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar correção atual`)
};

/**
* | output |
* | --- |
* | "Skip current correction" |
*
* @param {Spellcheck_Skip_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_skip_label = /** @type {((inputs?: Spellcheck_Skip_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Skip_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_skip_label(inputs)
	if (locale === "de") return de_spellcheck_skip_label(inputs)
	if (locale === "it") return it_spellcheck_skip_label(inputs)
	if (locale === "ru") return ru_spellcheck_skip_label(inputs)
	if (locale === "es") return es_spellcheck_skip_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_skip_label(inputs)
	if (locale === "ja") return ja_spellcheck_skip_label(inputs)
	if (locale === "hi") return hi_spellcheck_skip_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_skip_label(inputs)
	return en_spellcheck_skip_label(inputs)
});